import {Table,TableBody,TableCell,TableContainer,TableHead,TableRow,IconButton,Modal,Box} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '80%',
    bgcolor: 'background.paper',
    border: '2px solid #fff',
    borderRadius: '20px',
    boxShadow: 24,
    p: 4,
};

const ModalCutInfo =(props)=>{
 
     return(
        <div>
         <Modal
            open={props.openCutModal}
            onClose={props.handleCloseCutModal}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
         >
             <Box sx={style}>
             {props.cutInfo ? (
             <>
                 <div>
                 <b>INFORMACION DETALLADA</b>
                 <p> A continuacion vera la informacion de recortes del producto {props.cutInfo? props.cutInfo[0].productPrice.product.ref+' del cliente '+props.cutInfo[0].productPrice.client.name : ''}</p>
                 </div>
                 
                 <TableContainer>
                 <Table>
                     <TableHead>
                     <TableRow>
                         <TableCell>Producto</TableCell>
                         <TableCell>Color</TableCell>
                         <TableCell>Cantidad</TableCell>
                         <TableCell>Medida</TableCell>
                         <TableCell>Precio UND</TableCell>
                         <TableCell>Proceso</TableCell>
                     </TableRow>
                     </TableHead>
                     <TableBody>
                     {props.cutInfo?.map((od, index) => (
                         <TableRow key={index}>
                         <TableCell>{od.productPrice.product.ref}</TableCell>
                         <TableCell>{od.color.cod}</TableCell>
                         <TableCell>{od.quantity}</TableCell>
                         <TableCell>{od.type_quantity}</TableCell>
                         <TableCell>{od.price}</TableCell>
                         <TableCell>{od.cod_process}</TableCell>                         
                         </TableRow>
                     ))}
                     </TableBody>
                 </Table>
                 </TableContainer>
                 </>
             ) : (
                 'Cargando....'
             )}
             </Box>
         </Modal>
         </div>
     ) 
 }
 export default ModalCutInfo;